import { ApplicationConfig, Project } from '@frontend-site/shared/data';
import { State } from '@frontend-site/shared/utils';

export interface SessionState extends State {
    config?: ApplicationConfig;
    token?: string;
    ucn?: string;
    activeProject: Project | null;
    legacyAppVersion?: string;
}

export function createInitialState(): SessionState {
    return {
        activeProject: null,
        legacyAppVersion: '@fingerprint@'
    };
}
